<template>
  <div style="height: 100%;">
    <div class="header">
      <h3>阀门信息</h3>
      <!-- <p>展示各浏览器使用情况的环形图，支持点击交互和悬停效果</p> -->
    </div>
    
    <!-- <div class="chart-container"> -->
      <div class="chart-wrapper">
        <div ref="chart" style="width: 100%; height: 100%;"></div>
      <!-- </div> -->
    <!-- </div> -->
    
    <!-- <div class="data-info">
      <div class="data-item" v-for="(item, index) in data" :key="index">
        <div class="color-indicator" :style="{background: getColor(index)}"></div>
        {{ item.name }}: {{ item.value }}%
      </div>
    </div>
    
    <div class="controls">
      <button class="control-btn" @click="updateData">更新数据</button>
      <button class="control-btn" @click="resetData">重置数据</button>
    </div> -->
  </div>
</div>
</template>

<script>
// 注意：在Vue项目中需要先安装echarts: npm install echarts
import * as echarts from 'echarts'
import { left1Data } from '@/api/ksharge'

export default {
  name: 'BrowserChart',
  data() {
    return {
      myChart: null,
      data: [
        {
          value: null,
          name: '开阀数量',
          label: {
            color: '#fff'
          },
          itemStyle: {},
          emphasis: {
            itemStyle: {}
          }
        },
        {
          value: null,
          name: '关阀数量',
          label: {
            color: '#fff'
          },
          itemStyle: {},
          emphasis: {
            itemStyle: {}
          }
        },
        {
          value: null,
          name: '无阀数量',
          label: {
            color: '#fff'
          },
          itemStyle: {},
          emphasis: {
            itemStyle: {}
          }
        },
        {
          value: null,
          name: '阀异常数量',
          label: {
            color: '#fff'
          },
          itemStyle: {},
          emphasis: {
            itemStyle: {}
          }
        }
      ],
      data1: [],
      data2: [],
      data3: []
    }
  },
  computed: {
    chartOption() {
      return {
        backgroundColor: 'transparent',
        grid: {},
        polar: {},
        angleAxis: {
          show: false,
          interval: 1,
          type: 'category',
          data: [],
        },
        radiusAxis: {
          show: false
        },
        series: [
          {
            type: 'pie',
            radius: ["75%", "95%"],
            hoverAnimation: false,
            itemStyle: {
              color: 'transparent'
            },
            labelLine: {
              normal: {
                show: false,
                length: 30,
                length2: 55
              },
            },
            label: {
              normal: {
                position: 'inside',
                align: 'right'
              }
            },
            name: "",
            data: this.data1
          }, 
          {
            stack: 'a',
            type: 'pie',
            radius: ['80%', '45%'],
            roseType: 'area',
            zlevel: 10,
            minAngle: 0, // 允许值为0时也显示
            minShowLabelAngle: 0, // 最小显示标签的角度，设为0确保小数值也显示
            avoidLabelOverlap: false, // 不避免标签重叠，确保所有标签都显示
            itemStyle: {
              color: '#4169E1',
            },
            emphasis: {
              itemStyle: {
                color: '#6A5ACD'
              }
            },
            label: {
              normal: {
                show: true,
                textStyle: {
                  fontSize: 22,
                  color: '#FFD700'
                },
                position: function(params) {
                  // 当数值很小时（占比小于5%），使用外部位置确保标签可见
                  if (params.percent < 5 && params.percent > 0) {
                    return 'outside'
                  }
                  return 'inside'
                },
                rotate: 30,
                align: 'right',
                fontWeight: 'bold',
                formatter: function(params) {
                  // 确保即使值为0或很小也显示
                  const value = params.value !== null && params.value !== undefined ? params.value : 0
                  return value.toString()
                }
              },
              emphasis: {
                show: true,
                textStyle: {
                  color: '#FFD700'
                }
              }
            },
            labelLine: {
              normal: {
                show: function(params) {
                  // 当标签在外部时显示标签线
                  return params.percent < 5 && params.percent > 0
                },
                length: 10,
                length2: 5,
                lineStyle: {
                  color: '#fff'
                }
              }
            },
            animation: false,
            data: this.data3
          }, 
          {
            type: 'pie',
            zlevel: 99,
            radius: ["20%", "95%"],
            selectedOffset: 0,
            animation: false,
            hoverAnimation: false,
            label: {
              normal: {
                show: false,
              }
            },
            data: this.data2
          }
        ]
      }
    }
  },
  mounted() {
    this.prepareData()
    this.initChart()
    window.addEventListener('resize', this.handleResize)
    // 调用接口获取数据
    this.fetchData()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    if (this.myChart) {
      this.myChart.dispose()
    }
  },
  methods: {
    // 获取接口数据
    async fetchData() {
      try {
        // 获取 token
        const token = this.$store.state.print.goodsForeNo?.token || sessionStorage.getItem('token')
        // 构建请求参数
        const params = {
          token: token
        }
        const res = await left1Data(params)
        console.log('Bottom1 完整响应:', res)
        console.log('Bottom1 res.data:', res.data)
        console.log('Bottom1 res.data.data:', res.data?.data)
        
        // 获取实际数据，可能是 res.data.data 或 res.data
        let responseData = null
        if (res && res.data) {
          // 如果响应格式是 { status: 'success', data: {...} }
          if (res.data.status === 'success' && res.data.data) {
            responseData = res.data.data
          } 
          // 如果响应格式是 { status: 200, data: {...} }
          else if (res.data.status === 200 && res.data.data) {
            responseData = res.data.data
          }
          // 如果数据直接在 res.data 中
          else if (res.data.valve_open !== undefined || res.data.valve_closed !== undefined || 
                   res.data.valve_abnormal !== undefined || res.data.valve_none !== undefined) {
            responseData = res.data
          }
        }
        
        console.log('Bottom1 处理后的数据:', responseData)
        
        // 处理数据
        if (responseData) {
          // 如果是对象格式，包含阀门相关字段
          if (responseData.valve_open !== undefined || responseData.valve_closed !== undefined || 
              responseData.valve_abnormal !== undefined || responseData.valve_none !== undefined) {
            this.data = [
              {
                value: responseData.valve_open || 0,
                name: '开阀数量',
                label: {
                  color: '#fff'
                },
                itemStyle: {},
                emphasis: {
                  itemStyle: {}
                }
              },
              {
                value: responseData.valve_closed || 0,
                name: '关阀数量',
                label: {
                  color: '#fff'
                },
                itemStyle: {},
                emphasis: {
                  itemStyle: {}
                }
              },
              {
                value: responseData.valve_none || 0,
                name: '无阀数量',
                label: {
                  color: '#fff'
                },
                itemStyle: {},
                emphasis: {
                  itemStyle: {}
                }
              },
              {
                value: responseData.valve_abnormal || 0,
                name: '阀异常数量',
                label: {
                  color: '#fff'
                },
                itemStyle: {},
                emphasis: {
                  itemStyle: {}
                }
              }
            ]
            console.log('Bottom1 设置的数据:', this.data)
            
            // 重新准备图表数据
            this.prepareData()
            
            // 更新图表
            this.$nextTick(() => {
              if (this.myChart) {
                this.myChart.setOption(this.chartOption)
              }
            })
          }
        }
      } catch (error) {
        console.error('获取阀门统计数据失败:', error)
        // 接口失败时使用默认数据
      }
    },
    angleText(i, num) {
      // 每个元素的角度
      const everyAngle = 360 / num
      // 文字现在所在的角度
      const currentAngle = i * everyAngle + everyAngle / 2
      // 文字所在模块的所占角度
      const currentArea = (i + 1) * everyAngle
    
      if (currentAngle <= 90) {
        return -currentAngle
      } else if (currentAngle <= 180 && currentAngle > 90) {
        return 180 - currentAngle
      } else if (currentAngle < 270 && currentAngle > 180) {
        return 180 - currentAngle
      } else if (currentAngle < 360 && currentAngle >= 270) {
        return 360 - currentAngle
      }
    },
    prepareData() {
      // 有值的色图的正切处理
      this.data3 = JSON.parse(JSON.stringify(this.data))
      for (let i = 0; i < this.data3.length; i++) {
        // 确保标签始终显示，即使值为0
        if (!this.data3[i]['label']) {
          this.data3[i]['label'] = {}
        }
        this.data3[i]['label']['show'] = true
        // 确保值为0时也显示
        if (this.data3[i].value === null || this.data3[i].value === undefined) {
          this.data3[i].value = 0
        }
        if (i === 0) {
          this.data3[i]['label']['color'] = '#FFD700'
          this.data3[i]['itemStyle']['color'] = 'rgba(25, 255, 224)'
          this.data3[i]['emphasis']['itemStyle']['color'] = 'rgba(25, 255, 224)'
          this.data3[i]['label']['rotate'] = this.angleText(i, this.data3.length)
        } else {
          this.data3[i]['label']['color'] = '#FFD700'
          this.data3[i]['itemStyle']['color'] = '#4169E1'
          this.data3[i]['emphasis']['itemStyle']['color'] = '#6A5ACD'
          this.data3[i]['label']['rotate'] = this.angleText(i, this.data3.length)
        }
      }
      
      // 最外层大圈的数据
      this.data1 = JSON.parse(JSON.stringify(this.data))
      for (let i = 0; i < this.data1.length; i++) {
        this.data1[i].value = 1
        this.data1[i]['label']['rotate'] = this.angleText(i, this.data1.length)
        if (i === 0) {
          this.data1[i]['label']['color'] = 'rgba(25, 255, 224)'
        }
      }
      
      // 透明饼图的数据
      this.data2 = []
      for (let i = 0; i < this.data.length; i++) {
        if (i === 0) {
          this.data2.push({
            value: 1,
            itemStyle: {
              color: 'rgba(25, 255, 224,0.05)',
            }
          })
        } else {
          this.data2.push({
            value: 1,
            itemStyle: {
              color: 'transparent',
            }
          })
        }
      }
    },
    initChart() {
      this.myChart = echarts.init(this.$refs.chart)
      this.myChart.setOption(this.chartOption)
      
      // 添加事件监听
      this.addEventListeners()
    },
    addEventListeners() {
      this.myChart.on('click', (a) => {
        // 最外层的字体颜色重置变色
        for (let da1 = 0; da1 < this.chartOption.series[0].data.length; da1++) {
          this.chartOption.series[0].data[da1].label.color = '#fff'
        }
        
        // 色圈的字体颜色和选中颜色重置
        for (let da2 = 0; da2 < this.chartOption.series[1].data.length; da2++) {
          this.chartOption.series[1].data[da2].itemStyle.color = '#4169E1'
          this.chartOption.series[1].data[da2].label.color = '#FFD700'
          // 确保标签始终显示
          if (this.chartOption.series[1].data[da2].label) {
            this.chartOption.series[1].data[da2].label.show = true
          }
          // hover颜色重置
          this.chartOption.series[1].data[da2].emphasis.itemStyle.color = '#6A5ACD'
        }
        
        // 背景的透明饼图的重置
        for (let da3 = 0; da3 < this.chartOption.series[2].data.length; da3++) {
          this.chartOption.series[2].data[da3].itemStyle.color = 'transparent'
        }
        
        this.chartOption.series[1].data[a.dataIndex].itemStyle.color = 'rgba(25, 255, 224)'
        this.chartOption.series[1].data[a.dataIndex].label.color = '#FFD700'
        // 确保选中项的标签显示
        if (this.chartOption.series[1].data[a.dataIndex].label) {
          this.chartOption.series[1].data[a.dataIndex].label.show = true
        }
        // hover 颜色改变
        this.chartOption.series[1].data[a.dataIndex].emphasis.itemStyle.color = 'rgba(25, 255, 224)'
        this.chartOption.series[0].data[a.dataIndex].label.color = 'rgba(25, 255, 224)'
        this.chartOption.series[2].data[a.dataIndex].itemStyle.color = 'rgba(25, 255, 224,0.1)'
        
        this.myChart.setOption(this.chartOption)
      })
      
      this.myChart.on('mouseover', (a) => {
        this.myChart.dispatchAction({
          type: 'highlight',
          seriesIndex: 1,
          dataIndex: a.dataIndex
        })
      })
      
      this.myChart.on('mouseout', (a) => {
        this.myChart.dispatchAction({
          type: 'downplay',
          seriesIndex: 1,
          dataIndex: a.dataIndex
        })
      })
    },
    handleResize() {
      if (this.myChart) {
        this.myChart.resize()
      }
    },
    getColor(index) {
      if (index === 0) {
        return 'rgba(25, 255, 224)'
      } else {
        return '#4169E1'
      }
    },
    updateData() {
      // 模拟数据更新
      this.data = this.data.map(item => {
        const change = Math.floor(Math.random() * 20) - 10
        const newValue = item.value + change
        return {
          ...item,
          value: Math.max(10, Math.min(100, newValue))
        }
      })
      
      this.prepareData()
      this.$nextTick(() => {
        this.myChart.setOption(this.chartOption)
      })
    },
    resetData() {
      this.data = [
        {
          value: 100,
          name: '最大表码',
          label: {
            color: '#fff'
          },
          itemStyle: {},
          emphasis: {
            itemStyle: {}
          }
        },
        {
          value: 80,
          name: '最小表码',
          label: {
            color: '#fff'
          },
          itemStyle: {},
          emphasis: {
            itemStyle: {}
          }
        },
        {
          value: 65,
          name: '最大瞬时',
          label: {
            color: '#fff'
          },
          itemStyle: {},
          emphasis: {
            itemStyle: {}
          }
        },
        {
          value: 65,
          name: '最小瞬时',
          label: {
            color: '#fff'
          },
          itemStyle: {},
          emphasis: {
            itemStyle: {}
          }
        }
      ]
      
      this.prepareData()
      this.$nextTick(() => {
        this.myChart.setOption(this.chartOption)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  text-align: center;
  // margin-bottom: 40px;
  // padding: 20px;
  
  h3 {
    font-size: 24px;
    // margin-boheaderttom: 10px;
    background: linear-gradient(90deg, #19ffe0, #4169e1);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  }
  
  p {
    color: #8ca0d7;
    font-size: 16px;
    max-width: 600px;
    margin: 0 auto;
    line-height: 1.6;
  }
}

.chart-container {
  display: flex;
  justify-content: center;
  // margin-bottom: 40px;
  width: 100%;
  height: 100%;
}

.chart-wrapper {
  width: 100%;
  // max-width: 800px;
  height: 85%;
  // min-height: 400px;
  // background: rgba(16, 33, 77, 0.3);
  border-radius: 12px;
  // box-shadow: 0 10px 30px rgba(0, 20, 80, 0.4);
  // padding: 20px;
  // border: 1px solid rgba(64, 128, 255, 0.2);
}

.data-info {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 20px;
}

.data-item {
  background: rgba(20, 40, 80, 0.5);
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 16px;
  display: flex;
  align-items: center;
  border: 1px solid rgba(100, 150, 255, 0.2);
}

.color-indicator {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 10px;
}

.controls {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 30px;
}

.control-btn {
  background: rgba(30, 60, 120, 0.7);
  border: 1px solid rgba(100, 150, 255, 0.3);
  color: #b3ccf8;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
  
  &:hover {
    background: rgba(50, 100, 200, 0.7);
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(0, 50, 150, 0.3);
  }
}

@media (max-width: 768px) {
  .chart-wrapper {
    height: 400px;
    padding: 15px;
  }
  
  .header h1 {
    font-size: 26px;
  }
}
</style>